module.exports = __webpack_public_path__ + "static/img/logo.40f5119.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/logo.jpg
// module id = UI73
// module chunks = 1